/* Global ad-to-order helper: persists UTMs, decorates product links, tracks CTA clicks */
(function () {
  var isArticle = document.documentElement.className.indexOf('template-article') !== -1
               || location.pathname.indexOf('/blogs/') !== -1;

  var keys = ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','gclid','gbraid','wbraid'];

  // Capture ad params when they exist
  try {
    var p = new URLSearchParams(location.search);
    var stash = {};
    keys.forEach(function(k){ var v = p.get(k); if (v) stash[k] = v; });
    if (Object.keys(stash).length) sessionStorage.setItem('bt_qp', JSON.stringify(stash));
  } catch(e){}

  var saved = {};
  try { saved = JSON.parse(sessionStorage.getItem('bt_qp') || '{}'); } catch(e){}

  // If no params saved and we are not on an article, do nothing
  if (!Object.keys(saved).length && !isArticle) return;

  // Append UTMs to product links (works on initial DOM and lazy content)
  function decorateLinks(root){
    root.querySelectorAll('a[href^="/products"], a[href*="/products/"]').forEach(function(a){
      try {
        var url = new URL(a.getAttribute('href'), location.origin);
        keys.forEach(function(k){ if (saved[k] && !url.searchParams.has(k)) url.searchParams.set(k, saved[k]); });
        a.setAttribute('href', url.pathname + (url.search ? '?' + url.searchParams.toString() : ''));
      } catch(e){}
    });
  }
  decorateLinks(document);

  // Observe for sections/blocks that render later
  var mo = new MutationObserver(function(muts){
    muts.forEach(function(m){
      m.addedNodes.forEach(function(n){ if (n.nodeType === 1) decorateLinks(n); });
    });
  });
  mo.observe(document.documentElement, {subtree:true, childList:true});

  // Track CTA clicks (works anywhere). Prefer data-cta, fallback to generic label on blog.
  document.addEventListener('click', function(e){
    var link = e.target.closest('a');
    if (!link || typeof gtag !== 'function') return;
    var inArticle = !!link.closest('.bt-article') || isArticle;
    var label = (link.dataset && link.dataset.cta) || (inArticle ? 'bt_article_link' : null);
    if (!label) return;
    gtag('event','select_promotion',{
      promotion_name: label,
      creative_name: 'lander',
      items: [{ item_id: 'blu-mb-caps', item_name: 'Bluetropy Methylene Blue' }]
    });
  });
})();
